// extracted by mini-css-extract-plugin
export default {"DetailEvent":"DetailEvent_DetailEvent__O1mf7","brackRum":"DetailEvent_brackRum__x5OKy","cancel":"DetailEvent_cancel__nmNAq"};